module.exports = __webpack_public_path__ + "img/'.25f2be5f.svg";